import Heritage from '../assets/package/heritage1.jpg'
import Leisure from '../assets/package/leisure1.jpg'
import Pilgrimage from '../assets/package/pilgrimage1.jpg'
import Wildlife from '../assets/package/wildlife1.jpg'

import Ujjain from '../assets/destinations/ujjain.webp'
import Omkareshwar from '../assets/destinations/omkareshwar.jpeg'
import Indore from '../assets/destinations/indore.jpg'
import SatpuraTigerReserve from '../assets/destinations/satpura.jpg'
import Bhopal from '../assets/destinations/bhopal.webp'
import Pachmarhi from '../assets/destinations/pachmarhi.webp'
import Khajuraho from '../assets/destinations/khajuraho.jpg'
import Gwalior from '../assets/destinations/gwalior.jpg'
import Orchha from '../assets/destinations/orchha.jpeg'
import Panna from '../assets/destinations/panna.webp'
import PannaNationalPark from '../assets/destinations/panna-national-park.jpg'
import BandhavgarhNationalPark from '../assets/destinations/bandhavgarh.jpeg'
import KanhaNationalPark from '../assets/destinations/kanha.jpg'
import PenchNationalPark from '../assets/destinations/pench.jpg'
import Chanderi from '../assets/destinations/chanderi.avif'
import Datia from '../assets/destinations/datia.jpg'
import Sanchi from '../assets/destinations/sanchi.jpg'
import Islamnagar from '../assets/destinations/islamnagar.webp'
import Mandu from '../assets/destinations/mandu.webp'
import Vidisha from '../assets/destinations/vidisha.jpg'
import Shivpuri from '../assets/destinations/shivpuri.jpg'
import Jabalpur from '../assets/destinations/jabalpur.webp'
import MarbleRocks from '../assets/destinations/marblerocks.avif'
import Maheshwar from '../assets/destinations/maheshwar.webp'
import Amarkantak from '../assets/destinations/amarkantak.webp'
import Sonagiri from '../assets/destinations/sonagiri.jpg'
import Pushpagiri from '../assets/destinations/pushpagiri.jpg'
import Burhanpur from '../assets/destinations/burhanpur.webp'
import Chitrakoot from '../assets/destinations/chirtakoot.webp'


const hotelsData = {
    destinations: [

        // Heritage Category
        {
            category: "Heritage",
            image: Heritage,
            cities: [
                {
                    title: "Khajuraho",
                    image: Khajuraho,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "The Khajuraho Group of Monuments are a group of Hindu and Jain temples in Chhatarpur district, Madhya Pradesh, India, about 175 kilometres southeast of Jhansi. They are a UNESCO World Heritage Site. The temples are famous for their nagara-style architectural symbolism and less than 10% of their erotic sculptures." 
                        },
                        { 
                            description: "Most Khajuraho temples were built between 885 AD and 1050 AD by the Chandela dynasty. Historical records note that the Khajuraho temple site had 85 temples by the 12th century, spread over 20 square kilometers. Of these, only about 25 temples have survived, spread over six square kilometers Of the surviving temples, the Kandariya Mahadeva Temple is decorated with a profusion of sculptures with intricate details, symbolism and expressiveness of ancient Indian art." 
                        },
                        { 
                            description: "When these monuments were built, the boys in the place lived in hermitages, by being brahmcharis (bachelor) until they attained manhood and these sculptures helped them to learn about the worldly role of 'householder'.The Khajuraho group of temples were built together but were dedicated to two religions, Hinduism and Jainism, suggesting a tradition of acceptance and respect for diverse religious views among Hindus and Jains in the region." 
                        }
                    ],

                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Gwalior",
                    image: Gwalior,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Gwalior is a major city in the central Indian state of Madhya Pradesh; it lies in northern part of the state and is one of the Counter-magnet cities. Located 343 kilometres (213 mi) south of Delhi, the capital city of India, 120 kilometres (75 mi) from Agra and 414 kilometres (257 mi) from Bhopal, the state capital, Gwalior occupies a strategic location in the Gird region of India. The historic city and its fortress have been ruled by several historic northern Indian kingdoms. From the Kachchhapaghatas in the 10th century, Tomars in the 13th century, it was passed on to the Mughal Empire, then to the Maratha in 1754, followed by the Scindia in the 18th century. In April 2021, It was found that Gwalior had the best air quality index (AQI 152) amongst the 4 major cities in Madhya Pradesh" 
                        },
                        { 
                            description: "Besides being the administrative headquarters of Gwalior district and Gwalior division, Gwalior has many administrative offices of the Chambal division of northern Madhya Pradesh. Several administrative and judicial organisations, commissions and boards have their state and national headquarters situated in the city." 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Orchha",
                    image: Orchha,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Orchha (or Urchha) is a town in Niwari district of Madhya Pradesh state, India. The town was established by rajput ruler Rudra Pratap Singh some time after 1501, as the seat of an eponymous former princely state of covering parts of central & north India, in the Bundelkhand region. Orchha lies on the Betwa River, 80 km from Tikamgarh & 15 km from Jhansi in Uttar Pradesh." 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Chanderi",
                    image: Chanderi,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Chanderi, is a town of historical importance in Ashoknagar District of the state Madhya Pradesh in India. It is situated at a distance of 127 km from Shivpuri, 37 km from Lalitpur, 55 km from Ashok Nagar and about 46 km from Isagarh. It is surrounded by hills southwest of the Betwa River. Chanderi is surrounded by hills, lakes and forests and is spotted with several monuments of the Bundela Rajputs and Malwa sultans. It is famous for ancient Jain Temples. Its population in 2011 was 33,081." 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Datia",
                    image: Datia,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Datia is the district headquarter of the Datia District in north central Madhya Pradesh,a state of Central India. It is an ancient town, mentioned in the Mahabharata ruled by King Dantavakra. The city is 78 km from Gwalior, 325 km south of New Delhi and 344 km north of Bhopal. About 18 km from Datia is Sonagiri, a sacred Jain hill. Datia is also about 31 km from Jhansi and 52 km from Orchha. The nearest airport is at Gwalior. It was formerly the seat of the eponymous princely state in the British Raj. Datia is situated near Gwalior and on the border with Uttar Pradesh (U.P.)." 
                        },
                        { 
                            description: "The old town is surrounded by a stone wall, encompassing beautiful palaces and gardens. The 17th-century palace of Vir Singh Deo is a notable example of the Hindu architecture of North India. The town serves as a trading center for grains and cotton products. Handloom weaving is an important industry. Datia has several important landmarks and is famous for the seven-story up and seven-story down palace built by Raja Vir Singh Deo in 1614. The town is also a thriving pilgrimage spot for religious devotees." 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Sanchi",
                    image: Sanchi,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Sanchi is a Buddhist complex, famous for its Great Stupa, on a hilltop at Sanchi Town in Raisen District of the State of Madhya Pradesh, India. It is located in 46 kilometres (29 mi) north-east of Bhopal, capital of Madhya Pradesh." 
                        },
                        { 
                            description: "The Great Stupa at Sanchi is one of the oldest stone structures in India, and an important monument of Indian Architecture. It was originally commissioned by the Mauryan emperor Ashoka the Great in the 3rd century BCE. Its nucleus was a simple hemispherical brick structure built over the relics of the Buddha. It was crowned by the 'chhatra', a parasol-like structure symbolising high rank, which was intended to honour and shelter the relics. The original construction work of this stupa was overseen by Ashoka, whose wife Devi was the daughter of a merchant of nearby Vidisha. Sanchi was also her birthplace as well as the venue of her and Ashoka's wedding. In the 1st century BCE, four elaborately carved toranas (ornamental gateways) and a balustrade encircling the entire structure were added. The Sanchi Stupa built during Mauryan period was made of bricks. The composite flourished until the 11th century." 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Bhimbetka",
                    image: Sanchi,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "The Bhimbetka rock shelters are an archaeological site in central India that spans the Paleolithic and Mesolithic periods, as well as the historic period. It exhibits the earliest traces of human life in India and evidence of Stone Age starting at the site in Acheulian times. It is located in the Raisen District in the Indian state of Madhya Pradesh about 45 kilometres (28 mi) south-east of Bhopal. It is a UNESCO World Heritage Site that consists of seven hills and over 750 rock shelters distributed over 10 km (6.2 mi). At least some of the shelters were inhabited more than 100,000 years ago.The rock shelters and caves provide evidence of, according to Encyclopedia Britannica, a 'rare glimpse' into human settlement and cultural evolution from hunter-gatherers, to agriculture, and expressions of prehistoric spirituality." 
                        },
                        { 
                            description: "Bhimbetka rock art is considered oldest petroglyphs in the world, some of these similar to aboriginal rock art in Australia and the paleolithic Lascaux cave paintings in France. Of the 750 rock shelters, only 12 to 15 are open to visitors. 550 million years old Dickinsonia fossils of extinct genus of basal animals has been found at Bhimbetka" 
                        },
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Islamnagar",
                    image: Islamnagar,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Islamnagar is a panchayat village in the Bhopal district of Madhya Pradesh, India. It is located in the Huzur tehsil and the Phanda block. Formerly a fortified city, Islamnagar was the capital of the Bhopal princely state for a brief period. The ruins of the palaces built by Bhopal's founder Dost Mohammad Khan still exist at the site." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Mandu",
                    image: Mandu,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Mandu or Mandavgad is an ancient city in the present-day Mandav area of the Dhar district. It is located in the Malwa and Nimar region of western Madhya Pradesh, India, at 35 km from Dhar city. In the 11th century, Mandu was the sub division of the Tarangagadh or Taranga kingdom. This fortress town on a rocky outcrop about 100 km (62 mi) from Indore is celebrated for its architecture." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Burhanpur",
                    image: Burhanpur,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Burhanpur became a beautiful city, and many historical monuments survive in its expanse, mainly dating from the rule of the great Mughal emperor Shah Jahan. Burhanpur was an important Mughal outpost. Shah Jahan spent a considerable amount of time in this city, and helped add to the Shahi Qila. The Shahi Qila is one majestic palace in Burhanpur, located to the west of the Tapti River. Diwan-i-Aam and Diwan-i-Khas were built on the terrace of the Qila. Little of it remains today, as the Qila is mostly in ruins. However, the parts of the palace that are still standing display exquisite sculpture and carvings. The main attraction at the palace is the hamam or royal bath. It was specifically built for Shah Jahan's wife, Mumtaz Mahal so that she could enjoy a luxurious bath. It is said that she died there while giving birth to her fourteenth child. Even today, the ceiling has many intricate paintings. One of these paintings depicts a monument which is said to have been the inspiration for the Taj Mahal, her final resting place. She was initially buried there for six months before being moved. The original grave called the Aahukhana is in disrepair." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Vidisha",
                    image: Vidisha,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Vidisha (formerly known as Bhelsa and known as Besnagar in ancient times) is a city in central Madhya Pradesh, India. It is located 62.5 km northeast of the state capital, Bhopal. The name 'Vidisha' is derived from the nearby river 'Bais', mentioned in the Puranas.The district was created as Bhilsa District in 1904 by joining the tehsils of Vidisha (also known as Bhilsa) and Basoda, but not Basoda State, which were then part of Gwalior state. After India's independence in 1947, the former princely state of Gwalior became part of Madhya Bharat state, which was formed in 1948." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                }
            ]
        },

        // Leisure Category
        {
            category: "Leisure",
            image: Leisure,
            cities: [
                {
                    title: "Bhopal",
                    image: Bhopal,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Bhopal is the capital city of the Indian state of Madhya Pradesh and the administrative headquarters of both Bhopal district and Bhopal division. It is known as the City of Lakes for its various natural and artificial lakes and for being one of the greenest cities in India. It is the 16th largest city in India and 131st in the world. After formation of Madhya Pradesh, the state capital Bhopal was a part of the Sehore district. It was bifurcated in 1972 and a new district Bhopal was formed. Flourishing around 1707, the city was the capital of the former Bhopal State, a princely state of the British ruled by the Nawabs of Bhopal. Numerous heritage structures from this period include the Taj-ul-Masajid and Taj Mahal palace. In 1984, the city was struck by the Bhopal disaster, one of the worst industrial disasters in history." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Shivpuri",
                    image: Shivpuri,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Shivpuri is a city and a municipality in Shivpuri district located in the central Indian state of Madhya Pradesh. It is in the Gwalior Division of northwest Madhya Pradesh and is the administrative headquarters of Shivpuri District. It is situated at an altitude of 1,515 feet (462 m) above sea level.The city is a tourist destination in the monsoon season as it has a number of waterfalls like Bhura kho and Tunda Bharkha kho. Lakes in Shivpuri include Chandpatha jheel, Jadhav Sagar jheel, and other small lakes. The city is known for its greenery, forests and also as the former summer capital of the Scindia family who at one time ruled the Gwalior. The Indian leader Tatya Tope was hanged in Shivpuri in 1859. It also refers to a village in Muzaffarnagar." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Jabalpur",
                    image: Jabalpur,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Jabalpur (formerly Jubbulpore) is a city situated on the banks of Narmada River in the state of Madhya Pradesh, India. According to the 2011 census, it is the third-largest urban agglomeration in Madhya Pradesh and the country's 38th-largest urban agglomeration. Jabalpur is an important administrative, industrial and business center of Madhya Pradesh. The Madhya Pradesh High Court along with other important administrative headquarters of India and Madhya Pradesh are located in Jabalpur. It is generally accepted that the game of Snooker originated in Jabalpur. Jabalpur is the administrative headquarters of Jabalpur district (the second-most-populous district in Madhya Pradesh) and the Jabalpur division. It also is a major education centre in India. The city is known for the marble rocks on the river Narmada at Bhedaghat." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Pachmarhi",
                    image: Pachmarhi,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Embark on a mesmerizing journey to Pachmarhi with our meticulously crafted tour packages. Unveil the hidden gems of this enchanting destination and immerse yourself in its unparalleled beauty. With MP Holidays Pvt. Ltd., you can experience Pachmarhi tourism like never before. Explore the lush green forests, cascading waterfalls, and breathtaking viewpoints that adorn this picturesque hill station. Delight in the serenity of Bee Falls, witness the grandeur of Dhoopgarh sunset, and indulge in adventurous activities like trekking and rock climbing." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Marble Rocks",
                    image: MarbleRocks,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "The Marble Rocks is an area along the Narmada river in central India near the city of Jabalpur; in Bhedaghat of Jabalpur District, in the state of Madhya Pradesh. The river has carved the soft marble, creating a beautiful gorge of about 8 km in length. It is a popular Indian tourist destination. The local marble is mined and carved into various figures and transported all over India." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                }
            ]
        },

        // Pilgrimage Category
        {
            category: "Pilgrimage",
            image: Pilgrimage,
            cities: [
                {
                    title: "Ujjain",
                    image: Ujjain,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Ujjain is a city in Ujjain district of the Indian state of Madhya Pradesh. It is the fifth-largest city in Madhya Pradesh by population and is the administrative centre of Ujjain district and Ujjain division. It is one of the Hindu pilgrimage centres of Sapta Puri famous for the Kumbh Mela held there every 12 years. The famous temple of Mahakaleshwar Jyotirlinga is located in the center of the city." 
                        },
                        { 
                            description: "An ancient city situated on the eastern bank of the Shipra River, Ujjain was the most prominent city on the Malwa plateau of central India for much of its history. It emerged as the political centre of central India around 600 BCE. It was the capital of the ancient Avanti kingdom, one of the sixteen mahajanapadas. It remained an important political, commercial and cultural centre of central India until the early 19th century, when the British administrators decided to develop Indore as an alternative to it. Ujjain continues to be an important place of pilgrimage for Shaivites, Vaishnavites and followers of Shakta" 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Maheshwar",
                    image: Maheshwar,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Maheshwar is a town in Khargone district of Madhya Pradesh state, in central India. It is located on State Highway-38 (Barwaha- Bandheri Highway),13.5 km east of National Highway 3 (Agra-Mumbai highway) and 91 km from Indore, the commercial capital of the state. The Town lies on the north bank of the Narmada River. It was the kingdom of Chaktavartin Samrat Sahastraarjun, Kartavirya Arjuna a Heheya king. Lately, after many years, it was the capital of the Malwa during the Maratha Holkar reign till 6 January 1818, when the capital was shifted to Indore by Malhar Rao Holkar III." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Amarkantak",
                    image: Amarkantak,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Amarkantak is a pilgrim town and a Nagar Panchayat in Anuppur, Madhya Pradesh, India. The Amarkantak region is a unique natural heritage area and is the meeting point of the Vindhya and the Satpura Ranges, with the Maikal Hills being the fulcrum. This is where the Narmada River, the Son River and Johila River (Tributary of Son) emerge. Popular 15th-century Indian mystic and poet Kabir is said to have meditated on Kabir Chabutra, also called the platform of Kabir situated in the town of Amarkantak." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Chitrakoot",
                    image: Chitrakoot,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Chitrakoot is a pilgrimage centre and a nagar panchayat in the Satna district in the state of Madhya Pradesh, India. Connected to the Indian epic Ramayana, it is a place of religious, cultural, historical and archaeological importance, situated in the Bundelkhand region. It borders the Chitrakoot district in Uttar Pradesh, whose headquarters Chitrakoot Dham is located nearby. The city lies in the historical Chitrakoot region, which is divided between the present-day Indian states of Uttar Pradesh and Madhya Pradesh. It is known for a number of temples and sites mentioned in Hindu scriptures." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Sonagiri",
                    image: Sonagiri,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Sonagiri is a famous Jain pilgrimage site located near Datia in Madhya Pradesh, India. It is known for its beautiful cluster of white Jain temples spread across a small hill. The site holds religious significance for Digambar Jains, as it is believed that many Jain saints attained moksha (liberation) here." 
                        },
                        { 
                            description: "The main temple, dedicated to Lord Chandraprabhu (the 8th Jain Tirthankara), is among the most visited. The hill features around 100 Jain temples, offering a peaceful and spiritual atmosphere. Pilgrims and tourists visit Sonagiri to meditate, explore its historical temples, and enjoy the scenic views." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Pushpagiri",
                    image: Pushpagiri,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Pushpagiri is a well-known religious and historical site in India, attracting devotees and tourists due to its spiritual significance and ancient heritage. It is home to several temples and monuments that reflect the rich cultural and architectural history of the region. The serene environment and sacred atmosphere make it a popular destination for those seeking peace and devotion. Many pilgrims visit Pushpagiri to offer prayers, explore the historical sites, and experience the spiritual essence of the place." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                }
            ]
        },

        // Wildlife Category
        {
            category: "Wildlife",
            image: Wildlife,
            cities: [
                {
                    title: "Bandhavgarh National Park",
                    image: BandhavgarhNationalPark,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Bandhavgarh National Park is a national park of India, located in the Umaria district of Madhya Pradesh. Bandhavgarh, with an area of 105 square kilometres (41 sq mi), was declared a national park in 1968 and then became Tiger Reserve in 1993. The current core area is spread over 716 square kilometres (276 sq mi)." 
                        },
                        { 
                            description: "This park has a large biodiversity. The park has a large breeding population of leopards, and various species of deer. Maharaja Martand Singh of Rewa captured the first white tiger in this region in 1951. This white tiger, Mohan, is now stuffed and on display in the palace of the Maharajas of Rewa. Historically villagers and their cattle have been at a threat from the tiger. Rising mining activities around the park are putting the tigers at risk. The Park derived its name from the most prominent hill of the area which is said to have been given by Lord Rama to his brother Laxman to keep a watch on Lanka." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Kanha National Park",
                    image: KanhaNationalPark,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Kanha Tiger Reserve, also known as Kanha–Kisli National Park, is one of the tiger reserves of India and the largest national park of the state of Madhya Pradesh. The present-day Kanha area is divided into two protected areas, Hallon and Banjar, of 250 and 300 km2 (97 and 116 sq mi), respectively. Kanha National Park was created on 1 June 1955 and was designated a tiger reserve in 1973. Today, it encompasses an area of 940 km2 (360 sq mi) in the two districts Mandla and Balaghat." 
                        },
                        { 
                            description: "Together with a surrounding buffer zone of 1,067 km2 (412 sq mi) and the neighbouring 110 km2 (42 sq mi) Phen Sanctuary, it forms the Kanha Tiger Reserve, which is one of the biggest in the country. This makes it the largest national park in central India." 
                        },
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Panna National Park",
                    image: PannaNationalPark,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Panna National Park is a national park located in Panna and Chhatarpur districts of Madhya Pradesh in India. It has an area of 542.67 km2 (209.53 sq mi). It was declared in 1994 as the twenty second Tiger reserve of India and the fifth in Madhya Pradesh,[1] Panna was given the Award of Excellence in 2007 as the best maintained national park of India by the Ministry of Tourism of India. It is notable that by 2009, the entire tiger population had been eliminated by poaching with the collusion of forest department officials." 
                        },
                        
                        
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Pench National Park",
                    image: PenchNationalPark,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Pench National Park is a national park in India's Madhya Pradesh state, established in 1975 with an area of 257.26 km2 (99.33 sq mi). It includes Pench Tiger Reserve and derives its name from the Pench River that flows through the park from north to south dividing the park into almost equal western and eastern halves, the well-forested areas of Seoni and Chhindwara districts respectively. It was declared a sanctuary in 1965, raised to the status of national park in 1975 and enlisted as a tiger reserve in 1992." 
                        },
                        { 
                            description: "The national park consists of dry deciduous forests and much fauna and flora including tigers, various types of deer and birds. In 2011, the park won the 'Best Management Award'. This park is accessible from Pauni on National Highway 7 and has two famous entry gates, Turiya and Karmajhiri."
                        },
          
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
                {
                    title: "Satpura Tiger Reserve",
                    image: SatpuraTigerReserve,
                    description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures.",
                    content: [
                        { 
                            description: "Satpura Tiger Reserve (STR) also known as Satpura National Park is located in the Hoshangabad District (newly named Narmadapuram ) of Madhya Pradesh in India. Its name is derived from the Satpura range. It covers an area of 524 km2 (202 sq mi). Satpura National Park, along with the adjoining Bori and Pachmarhi wildlife sanctuaries, provides 2,200 km2 (850 sq mi) of unique central Indian highland ecosystem. It was set up in 1981." 
                        },
                        { 
                            description: "Satpura National Park is rich in biodiversity. The animals here include leopard, sambar, chital, Indian muntjac, nilgai, four-horned antelope, Chinkara, wild boar, bear, black buck, fox, porcupine, flying squirrel, mouse deer, and Indian giant squirrel. There are a variety of birds. Hornbills and peafowl are common birds found here. The flora consists of mainly sal, teak, tendu, Phyllanthus emblica, mahua, bel, bamboo, and grasses and medicinal plants."
                        },
          
                    ],
                    properties: 2,
                    hotels: [
                        {
                            name: "Rudraksh Club & resort",
                            images: [],
                            description: "A UNESCO World Heritage site, famous for its stunning medieval-era temples and sculptures."
                        }
                    ]
                },
            ]
        }
    ]
};

export default hotelsData;